import {
  HTTP_SENDEMAILBUHEAD_FETCHING,
  HTTP_SENDEMAILBUHEAD_SUCCESS,
  HTTP_SENDEMAILBUHEAD_FAILED,
  server,
  OK,
  YES,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";

export const setStateSendemailBuheadToFetching = () => ({
  type: HTTP_SENDEMAILBUHEAD_FETCHING,
});

export const setStateSendemailBuheadToSuccess = (payload) => ({
  type: HTTP_SENDEMAILBUHEAD_SUCCESS,
  payload,
});

export const setStateSendemailBuheadToFailed = (payload) => ({
  type: HTTP_SENDEMAILBUHEAD_FAILED,
});

export const sendEmailBuhead = (item) => {
  return async (dispatch) => {
    dispatch(setStateSendemailBuheadToFetching());

    try {
      const result = await httpClient.post(
        `${server.SENDMAILBUHEAD_URL}`,
        item
      );
      dispatch(setStateSendemailBuheadToSuccess(result.data));
    } catch (err) {
      dispatch(setStateSendemailBuheadToFailed());
    }
  };
};
